import React from "react";
import styles from '../utilities/cssmodules/Notifications.module.css';


const NotificationsContent = () => {
    return (  
        <div className="component-wrapper">
            <div className="component-title">Notifications</div>
        </div>
    );
}
 
export default NotificationsContent;